import { useCallback, useMemo } from 'react'
import { MainButton } from '../../../Button/MainButton'
import { DangerButton } from '../../../Button/DangerButton'
import { Dialog, DialogContent, DialogTitle, makeStyles } from '@material-ui/core'
import { FONT_WEIGHTS } from '../../../../utils'
import { dangers } from '../../../../utils/colors'
import moment from 'moment'

const useStyles = makeStyles(() => ({
	content: { display: 'flex', flexDirection: 'column', gap: '.6rem' },
	header: {
		display: 'flex',
		marginBottom: '.8rem',
		justifyContent: 'flex-end',
		gap: '.5rem',
		'& div:nth-child(1)': {
			flex: 1,
			display: 'flex',
			alignItems: 'center'
		}
	},
	titleText: {
		fontWeight: FONT_WEIGHTS.ExtraBold,
		fontSize: '1rem',
		textTransform: 'uppercase'
	},
	actionsContainer: {
		justifyContent: 'flex-start',
		marginTop: '1rem',
		display: 'flex',
		flexDirection: 'row',
		gap: '1rem',
		marginTop: '2rem',
		height: '2.5rem'
	},
	deleteButton: {
		alignSelf: 'flex-start',
		color: dangers[500],
		fontFamily: 'Nunito',
		fontSize: '0.875rem',
		fontWeight: FONT_WEIGHTS.ExtraBold,
		letterSpacing: '0.078125rem',
		textTransform: 'uppercase',
		padding: '.5rem 0 !important'
	},
	mainActions: {
		display: 'flex',
		flexDirection: 'row',
		alignSelf: 'flex-start',
		gap: '1rem',
		'& .MuiButton-outlinedSizeLarge': {
			height: 'unset'
		}
	}
}))

const RemoveLatePickupDialog = ({
	open,
	onClose,
	onCancel,
	onDelete,
	hasEveningMeal = false,
	standardPickupTime = ''
}) => {
	const classes = useStyles()

	const text = useMemo(() => {
		let text = 'Are you sure you want to remove Late Pick-up?'
		if (hasEveningMeal) {
			text += ` If you continue, the evening meal you selected will no longer be valid, and it will be removed from the client's food schedule. They will also need to pick-up their pet(s) by ${moment(
				standardPickupTime,
				'HH:mm'
			).format('h:mma')}`
		} else {
			text += ` If you continue, the client will need to pick-up their pet(s) by ${moment(
				standardPickupTime,
				'HH:mm'
			).format('h:mma')}.`
		}

		return text
	}, [hasEveningMeal, standardPickupTime])

	const handleOnClose = useCallback(() => {
		if (onClose) {
			onClose()
		}
	}, [onClose])

	const handleOnCancel = useCallback(() => {
		if (onCancel) {
			onCancel()
		}
	}, [onCancel])

	const handleOnDelete = useCallback(() => {
		if (onDelete) {
			onDelete()
		}
	}, [onDelete])

	return (
		<Dialog
			PaperProps={{
				style: {
					width: 400,
					maxWidth: 400,
					maxHeight: 400,
					minWidth: 400
				}
			}}
			maxWidth="md"
			open={open}
			onClose={handleOnClose}>
			<DialogTitle>
				<div className={classes.header}>
					<div className={classes.titleText}>Remove Late Pick-up</div>
				</div>
			</DialogTitle>
			<DialogContent className={classes.content}>
				<div>{text}</div>
			</DialogContent>
			<div className={classes.actionsContainer}>
				<DangerButton
					label={'Delete'}
					variant="contained"
					className={classes.deleteButton}
					onClick={handleOnDelete}
				/>
				<div className={classes.mainActions}>
					<MainButton
						style={{ paddingTop: '4px', paddingBottom: '4px', height: 'unset' }}
						variant="outlined"
						label="Cancel"
						onClick={handleOnCancel}
					/>
				</div>
			</div>
		</Dialog>
	)
}

export default RemoveLatePickupDialog
